import { IProduct, ProductCreationPayload } from "@modules/product/types";

import { IProductFormData, ImageCreationType } from "./types";

export const prepareImageUploadPromises = (
  uploadedFileList: FileList | null,
  createImage: ImageCreationType
) => {
  if (!uploadedFileList) {
    return
  }

  const list = Array.from(uploadedFileList).map((file) => {
    // when will develop product update
    if (!(file instanceof FileList)) {
    //   return Promise.resolve(file.url)
    }

    const formData = new FormData();

    formData.append('files[]', file);

    const response = createImage(formData).unwrap()

    return response
  })

  return list
};

export const prepareClonedData = (
  data: IProductFormData,
  imagePaths: string[],
  uploadedIcons: string[]
): ProductCreationPayload => {
  // The during of creation or updating we send all images, existing and new uploaded
  // the in backend we do all process
  // we exclude deleted items and deleting data by missing ids in payload

  const {
    mainImageUrl,
    existingImages,
    existingIcons,
    uploadedFileList,
    uploadedIconList,
    category,
    ...restOfData
  } = data as any;

  // uploadedFileList exclude from payload
  const array = existingImages?.map((img: { id: any }) => img.id) || []
  const arrayIcons = existingIcons?.map((img: { id: any }) => img.id) || []

  let mainImageId = null

  if (mainImageUrl) {
    const [_, src] = mainImageUrl.split('images/')
    const path = `images/${src}`;

    mainImageId = existingImages?.find((image: { url: string }) => image.url === path)?.id || ''
  }

  return {
    ...restOfData,
    categoryId: data.categoryId || null,
    // eslint-disable-next-line no-unsafe-optional-chaining
    icons: uploadedIcons.length ? uploadedIcons : arrayIcons,
    // new uploaded and existing images together
    images: [...imagePaths, ...array],
    mainImageId
  } as unknown as ProductCreationPayload;
};
